exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trip-data em[data-v-eae91dc2] {\r\n    display: block;\r\n    width: 50%;\r\n    padding-top: 6px;\r\n    float: left;\n}\n.trip-data em[data-v-eae91dc2] > * {\r\n    vertical-align: middle;\n}\n.trip-data em .fa[data-v-eae91dc2] {\r\n    padding-right: 6px;\n}\n.trip-data em .svgItem[data-v-eae91dc2] {\r\n    height: 25px;\r\n    display: inline-block;\r\n    padding-right: 6px;\n}\n.trip-data--subtitle[data-v-eae91dc2] {\r\n    font-weight: bold;\r\n    display: block;\n}\r\n", ""]);

// exports
